import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/admin/dashboard/dashboard.component';
import { AssessmentCreateComponent } from './pages/admin/assessment-create/assessment-create.component';
import { WardManageComponent } from './pages/admin/ward-manage/ward-manage.component';
import { AssessmentPrintComponent } from './pages/admin/assessment-print/assessment-print.component';
import { HoldingCardPrintComponent } from './pages/admin/holding-card-print/holding-card-print.component';
import { MultipleAssessmentCreateComponent } from './pages/admin/multiple-assessment-create/multiple-assessment-create.component';
import { AuthComponent } from './pages/auth/auth.component';
import { AdminComponent } from './pages/admin/admin.component';
import { UnionManageComponent } from './pages/admin/union-manage/union-manage.component';
import { UnionsListComponent } from './pages/admin/unions-list/unions-list.component';
import { UnionSuspendedComponent } from './pages/union-suspended/union-suspended.component';
import { UnionMaintenanceComponent } from './pages/union-maintenance/union-maintenance.component';
import { AuthGuard, LoginGuard, RootGuard } from './guard/auth.guard';
import { SuperAdminGuard } from './guard/super-admin.guard';
import { ManagerGuard } from './guard/manager.guard';
import { ManagerOrSuperAdminGuard } from './guard/manager-or-admin.guard';
import { UpCardPrintComponent } from './pages/admin/up-card-print/up-card-print.component';
import { UsersStatusComponent } from './pages/users-status/users-status.component';
import { TaxCollectionComponent } from './pages/admin/tax-collection/tax-collection.component';
import { TaxCollectionListComponent } from './pages/admin/tax-collection-list/tax-collection-list.component';
import { TaxCollectionReceiptComponent } from './pages/admin/tax-collection-receipt/tax-collection-receipt.component';
import { QuickSmsServiceComponent } from './pages/admin/quick-sms-service/quick-sms-service.component';
import { AssessmentPageComponent } from './pages/admin/assessment-page/assessment-page.component';
import { ImageUploadComponent } from './pages/admin/image-upload/image-upload.component';
import { UserManagementComponent } from './pages/admin/user-management/user-management.component';
import { BulkTaxCollectionComponent } from './pages/admin/bulk-tax-collection/bulk-tax-collection.component';
import { ProfileSettingsComponent } from './pages/admin/profile-settings/profile-settings.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [RootGuard],
    children: []
  },
  {
    path: 'auth',
    component: AuthComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('./pages/auth/login/login.module').then((m) => m.LoginModule),
      },
    ],
  },
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'assessment-create', component: AssessmentCreateComponent },
      { path: 'ward-manage', component: WardManageComponent, canActivate: [ManagerOrSuperAdminGuard] },
              { path: 'union-manage', component: UnionManageComponent, canActivate: [ManagerOrSuperAdminGuard] },
        { path: 'unions-list', component: UnionsListComponent, canActivate: [SuperAdminGuard] },
      { path: 'assessment-print', component: AssessmentPrintComponent },
      { path: 'holding-card-print', component: HoldingCardPrintComponent },
      { path: 'up-card-print', component: UpCardPrintComponent },
      {
        path: 'multiple-assessment-create',
        component: MultipleAssessmentCreateComponent,
      },
      { path: 'tax-collection', component: TaxCollectionComponent },
      { path: 'tax-collection-list', component: TaxCollectionListComponent },
      { path: 'tax-collection-receipt', component: TaxCollectionReceiptComponent },
      { path: 'bulk-tax-collection', component: BulkTaxCollectionComponent },
      { path: 'quick-sms-service', component: QuickSmsServiceComponent },
      { path: 'assessment-page', component: AssessmentPageComponent },
      { path: 'image-upload', component: ImageUploadComponent, canActivate: [SuperAdminGuard] },
      { path: 'user-management', component: UserManagementComponent, canActivate: [ManagerOrSuperAdminGuard] },
      { path: 'profile-settings', component: ProfileSettingsComponent },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'users-status',
    component: UsersStatusComponent,
  },
  {
    path: 'union-suspended',
    component: UnionSuspendedComponent,
  },
  {
    path: 'union-maintenance',
    component: UnionMaintenanceComponent,
  },
  // Fallback route
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
